document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('[data-ap-menu-toggle]');
  function closeMenu(){
    document.body.classList.remove('ap-mobile-menu-open');
    toggles.forEach(function(btn){ btn.setAttribute('aria-expanded','false'); });
  }
  toggles.forEach(function(toggle){
    toggle.setAttribute('aria-expanded','false');
    toggle.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      var isOpen = document.body.classList.toggle('ap-mobile-menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function(event){
    if (!document.body.classList.contains('ap-mobile-menu-open')) return;
    if (event.target.closest('.ap-header')) return;
    closeMenu();
  });
  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') closeMenu();
  });
  document.querySelectorAll('.ap-menu a').forEach(function(link){
    link.addEventListener('click', closeMenu);
  });
});
